// Import from NPM
// -------------------------------------
import React, { useState } from "react";
import { Image } from "semantic-ui-react";
import { Div } from "@components/Generics.react";

export default function BuilderHeader(props) {
    const {
        image,
        header,
        description,
        imgWidth = "256px",
        forceImage = false,
    } = props;
    const isPortrait = window.innerHeight > window.innerWidth;
    const imgWd = isPortrait ? "100%" : imgWidth;
    const showImage = image && (window.innerHeight < 720 || forceImage);

    const ImageWithFallback = ({ src, fallbackSrc }) => {
        const [imgSrc, setImgSrc] = useState(src);

        const handleError = () => {
            setImgSrc(fallbackSrc);
        };

        return <Image fluid src={imgSrc} onError={handleError} />;
    };

    // ========================= Render Function =================================
    return (
        <Div
            medpad={!isPortrait}
            white
            flex
            snubbed
            hintShadow={!isPortrait}
            fluid
            flexStart
            column={isPortrait}
        >
            {showImage && (
                <Div wd={imgWd} noOverflow slightShadow>
                    <ImageWithFallback
                        src={image}
                        fallbackSrc={"/assets/images/configurable/missing.jpg"}
                        style={{ width: imgWd }}
                    />
                </Div>
            )}
            <Div
                wd={`calc(100% - ${!isPortrait && showImage ? imgWd : "0px"})`}
            >
                <Div
                    fluid
                    relaxed
                    basepad
                    ash
                    big
                    bold
                    style={{
                        paddingLeft: isPortrait && !showImage ? "60px" : "15px",
                    }}
                >
                    {header}
                </Div>
                <Div fluid relaxed basepad>
                    {description}
                </Div>
            </Div>
        </Div>
    );
}
